module.exports = __webpack_public_path__ + "img/10_26@3x.0a15c271.png";